<template>
  <footer>
    <p>Copyright © 2022 Faysal FM</p>
  </footer>
</template>

<style scoped>
p {
  max-width: 100%;
  min-height: 2vh;
  padding-top: 30px;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #383838;
  font-family: Poppins;
  font-weight: 500;
}
</style>